export default "./images/survio-10FbX-assets-summary-results-24.svg";